<template>
  <input
    :type="type"
    :disabled="disabled"
    :value="value"
    :placeholder="placeholder"
    class="widget_input"
    @change="onChange"
    @blur="onBlur"
    @focus="onFocus"
    @keyup="onKeyup"
    @keydown="onKeydown"
    @click="onClick"
  />
</template>

<script>
export default {
  name: "widget_input",
  props: {
    type: {
      type: String,
      default: "text",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {
    onChange(e) {
      let vm = this;
      vm.$emit("change", e);
    },
    onBlur(e) {
      let vm = this;
      vm.$emit("blur", e);
    },
    onFocus(e) {
      let vm = this;
      vm.$emit("focus", e);
    },
    onKeyup(e) {
      let vm = this;
      vm.$emit("input", e.target.value);
    },
    onKeydown(e) {
      let vm = this;
      vm.$emit("input", e.target.value);
    },
    onClick(e) {
      let vm = this;
      vm.$emit("click", e);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/scss/constant_valiable.scss";
.widget_input {
  padding: 14px 10px;
  border-radius: 5px;
  width: 100%;
  position: relative;
  background: #fff;
  border-width: 1px;
  border-style: solid;
  outline: none;
  border-color: #c3cad9;
}
</style>
